import React from "react";
import ContactHeroSec from "../pagesections/ContactHeroSec";
import Footer from "../pagesections/Footer";
import "./contact.css";
import ContactContainer from "./contactContainer";

const Contactus = () => {
  return (
    <div className="contact-us">
      <ContactHeroSec />
      <ContactContainer />
      <div className="contact-us-footer-space">
        <Footer />
      </div>
    </div>
  );
};

export default Contactus;
